import type { PRRecord } from "@/lib/exerciseApi";

interface WODHistoryListProps {
  prs: PRRecord[];
}

function formatValue(pr: PRRecord): string {
  if (pr.benchmark_type === "benchmark_wod" || pr.benchmark_type === "station_time") {
    const m = Math.floor(pr.value / 60);
    const s = Math.round(pr.value % 60);
    return `${m}:${s.toString().padStart(2, "0")}`;
  }
  return `${pr.value} ${pr.unit}`;
}

export function WODHistoryList({ prs }: WODHistoryListProps) {
  const crossfitPrs = prs.filter((p) => p.sport === "crossfit" || p.benchmark_type === "benchmark_wod");

  if (!crossfitPrs.length) {
    return (
      <div className="rounded-xl border border-border/60 p-4">
        <h3 className="text-sm font-semibold mb-3">Recent CrossFit PRs</h3>
        <div className="h-[120px] flex items-center justify-center text-muted-foreground text-sm">
          No CrossFit PRs recorded yet.
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-border/60 p-4">
      <h3 className="text-sm font-semibold mb-3">Recent CrossFit PRs</h3>
      <div className="space-y-1.5">
        {crossfitPrs.slice(0, 8).map((pr, idx) => (
          <div
            key={`${pr.benchmark_name}-${idx}`}
            className="flex items-center justify-between px-2 py-1.5 rounded hover:bg-white/[0.03] transition-colors"
          >
            <div>
              <span className="text-xs font-medium text-foreground">{pr.benchmark_name}</span>
              <span className="text-[10px] text-muted-foreground ml-2">
                {pr.recorded_at ? new Date(pr.recorded_at).toLocaleDateString() : ""}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs font-mono tabular-nums text-foreground">{formatValue(pr)}</span>
              <span className="text-amber-400 text-[10px] font-bold">PR</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
